import React, { useState } from 'react';
import { AppDispatch, RootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box, Button, Divider, FormControl, FormControlLabel,
    FormLabel, Radio, RadioGroup, Typography,
} from '@mui/material';

const BG_SECTION     = '#1c1c24';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE  = '1px solid rgba(255,255,255,0.08)';

const radioSx = {
    color: TEXT_SECONDARY,
    '&.Mui-checked': { color: BRAND_RED },
    '&.Mui-disabled': { color: 'rgba(255,255,255,0.2)' },
};

const formLabelSx = {
    color: TEXT_SECONDARY,
    fontWeight: 600,
    fontSize: '0.8rem',
    letterSpacing: 1,
    textTransform: 'uppercase' as const,
    mb: 1,
    '&.Mui-focused': { color: BRAND_RED },
};

export function PrivacityUserConfigForm() {
    const dispatch    = useDispatch<AppDispatch>();
    const authHeaders = useSelector((state: RootState) => state.session.authHeaders);
    const contentsPrivacityId = useSelector((state: RootState) => state.sessionUserConfig.userPrivacityConfigurations.contents.userPrivacityId);
    const projectsPrivacityId = useSelector((state: RootState) => state.sessionUserConfig.userPrivacityConfigurations.projects.userPrivacityId);

    const [inputContentsPrivacityType, setInputContentsPrivacityType] = useState(contentsPrivacityId);
    const [inputProjectsPrivacityType, setInputProjectsPrivacityType] = useState(projectsPrivacityId);

    function handleChangePrivacityConfig() {
        // API integration pending
    }

    return (
        <Box sx={{ bgcolor: BG_SECTION, borderRadius: '10px', border: BORDER_SUBTLE, p: { xs: 2, sm: 3 } }}>
            <Typography fontWeight={600} color={TEXT_PRIMARY} mb={{ xs: 2, sm: 3 }} sx={{ fontSize: { xs: '0.95rem', sm: '1.1rem', md: '1.25rem' } }}>
                Privacy Settings
            </Typography>

            {/* Contents */}
            <FormControl component='fieldset' fullWidth>
                <FormLabel component='legend' sx={formLabelSx}>Contents</FormLabel>
                <RadioGroup
                    value={inputContentsPrivacityType}
                    onChange={(e) => setInputContentsPrivacityType(Number(e.target.value))}
                >
                    <FormControlLabel
                        value={1} label='Everybody'
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_PRIMARY }}
                    />
                    <FormControlLabel
                        value={2} label='Fellows Only' disabled
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_SECONDARY }}
                    />
                    <FormControlLabel
                        value={3} label='Selected Fellows' disabled
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_SECONDARY }}
                    />
                    <FormControlLabel
                        value={4} label='Nobody' disabled
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_SECONDARY }}
                    />
                </RadioGroup>
            </FormControl>

            <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)', my: 3 }} />

            {/* Projects */}
            <FormControl component='fieldset' fullWidth>
                <FormLabel component='legend' sx={formLabelSx}>Projects</FormLabel>
                <RadioGroup
                    value={inputProjectsPrivacityType}
                    onChange={(e) => setInputProjectsPrivacityType(Number(e.target.value))}
                >
                    <FormControlLabel
                        value={1} label='Everybody'
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_PRIMARY }}
                    />
                    <FormControlLabel
                        value={2} label='Fellows Only' disabled
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_SECONDARY }}
                    />
                    <FormControlLabel
                        value={3} label='Selected Fellows' disabled
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_SECONDARY }}
                    />
                    <FormControlLabel
                        value={4} label='Nobody' disabled
                        control={<Radio size='small' sx={radioSx} />}
                        sx={{ color: TEXT_SECONDARY }}
                    />
                </RadioGroup>
            </FormControl>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                    variant='contained'
                    onClick={handleChangePrivacityConfig}
                    sx={{ bgcolor: BRAND_RED, textTransform: 'none', fontWeight: 600, px: 4, '&:hover': { bgcolor: '#a93226' } }}
                >
                    Save Changes
                </Button>
            </Box>
        </Box>
    );
}
